/**
 * @generated SignedSource<<ea673c42bc29a41d84cd82a5dca60d17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TopicsAdminDetailSaveRoutingMutation$variables = {
  teamIds: ReadonlyArray<string>;
  topicId: string;
};
export type TopicsAdminDetailSaveRoutingMutation$data = {
  readonly store: {
    readonly setTopicTeams: {
      readonly description: string | null;
      readonly name: string;
      readonly teams: ReadonlyArray<{
        readonly id: string;
      }> | null;
    };
  };
};
export type TopicsAdminDetailSaveRoutingMutation = {
  response: TopicsAdminDetailSaveRoutingMutation$data;
  variables: TopicsAdminDetailSaveRoutingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topicId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "teamIds",
    "variableName": "teamIds"
  },
  {
    "kind": "Variable",
    "name": "topicId",
    "variableName": "topicId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "teams",
  "plural": true,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TopicsAdminDetailSaveRoutingMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "StoreTopic",
            "kind": "LinkedField",
            "name": "setTopicTeams",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TopicsAdminDetailSaveRoutingMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreMutations",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "StoreTopic",
            "kind": "LinkedField",
            "name": "setTopicTeams",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e5e0947fdb35859e1cf3a449e47182e9",
    "id": null,
    "metadata": {},
    "name": "TopicsAdminDetailSaveRoutingMutation",
    "operationKind": "mutation",
    "text": "mutation TopicsAdminDetailSaveRoutingMutation(\n  $topicId: ID!\n  $teamIds: [ID!]!\n) {\n  store {\n    setTopicTeams(topicId: $topicId, teamIds: $teamIds) {\n      name\n      description\n      teams {\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "634846c660e4259a2a5e90bd357cab07";

export default node;
